/* Local guide navigation only. No customer data, requests or form actions. */
(() => {
  'use strict';
  function init(root) {
    if (!root || root.dataset.zvSupportReady) return;
    root.dataset.zvSupportReady = 'true';
    const controller = new AbortController();
    const { signal } = controller;
    const chapters = [...root.querySelectorAll('[data-zv-support-chapter]')];
    const links = [...root.querySelectorAll('.zv-app-handleiding__toc [data-zv-support-link]')];
    const select = root.querySelector('[data-zv-support-select]');
    const navigation = window.ZVGuideNavigation.create({ root, sections: chapters, links, select });
    function openTarget(hash, focus) {
      if (!hash || hash === '#') return;
      let id;
      try { id = decodeURIComponent(hash.slice(1)); } catch { return; }
      const target = document.getElementById(id);
      if (!target || !root.contains(target)) return;
      if (target instanceof HTMLDetailsElement) target.open = true;
      let ancestor = target.parentElement;
      while (ancestor && ancestor !== root) {
        if (ancestor instanceof HTMLDetailsElement) ancestor.open = true;
        ancestor = ancestor.parentElement;
      }
      const chapter = target.closest('[data-zv-support-chapter]');
      if (chapter) navigation.mark(chapter);
      requestAnimationFrame(() => {
        target.scrollIntoView({ block: 'start', behavior: 'instant' });
        if (focus) {
          const heading = target.matches('details') ? target.querySelector('summary') : target.querySelector('h2,h3');
          if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); }
        }
      });
    }
    root.addEventListener('click', event => {
      const link = event.target.closest('a[data-zv-support-link],a[data-zv-support-next]');
      if (!link || !root.contains(link) || !link.hash) return;
      event.preventDefault();
      if (location.hash !== link.hash) history.pushState(null, '', link.hash);
      openTarget(link.hash, true);
    }, { signal });
    select?.addEventListener('change', () => {
      if (!select.value) return;
      history.pushState(null, '', select.value);
      openTarget(select.value, true);
    }, { signal });
    window.addEventListener('hashchange', () => openTarget(location.hash, true), { signal });
    window.addEventListener('popstate', () => openTarget(location.hash, true), { signal });
    if (location.hash) openTarget(location.hash, false);
    root.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
      controller.abort(); navigation.destroy(); delete root.dataset.zvSupportReady;
    }, { signal, once: true });
  }
  document.querySelectorAll('[data-zv-installation-support]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-zv-installation-support]').forEach(init));
})();
